export default {
  nav: {
    home: '首页',
    products: '产品中心',
    about: '品牌介绍',
    media: '媒体中心',
    buyNow: '前往购买'
  },
  footer: {
    company: '长江润滑油',
    description: '致力于为全球客户提供高品质润滑油产品和解决方案',
    quickLinks: '快速链接',
    contactInfo: '联系方式',
    address: '地址：中国石油大厦',
    phone: '电话：400-888-8888',
    email: '邮箱：info@changjiang.com',
    copyright: '© 2024 长江润滑油. 版权所有',
    scanQR: '扫码关注'
  },
  home: {
    heroTitle: '长江润滑油',
    heroSubtitle: '品质成就未来',
    aboutTitle: '关于我们',
    brandIntro: '品牌介绍',
    productSelection: '产品精选',
    brandAdvantages: '品牌优势',
    mediaCenter: '媒体中心',
    partners: '合作伙伴',
    readMore: '了解更多',
    exploreMore: '探索更多'
  }
}
